import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../../nav_bar/Navbar";
import Footer from "../../footer/Footer";
import { fetchQuickBoostList } from "./quickBoostService";
import "./QuickBoostPage.css";

const QuickBoostPage = () => {
 const [items, setItems] = useState([]);
 const [loading, setLoading] = useState(false);
 const [page, setPage] = useState(0);
 const [totalPages, setTotalPages] = useState(0);
 const [totalItems, setTotalItems] = useState(0);
 const navigate = useNavigate();

 const loadItems = useCallback(async () => {
 setLoading(true);
 const res = await fetchQuickBoostList({ page, size: 20 });
 if (res.status === 200 && res.data?.status) {
 setItems(res.data.data || []);
 setTotalPages(res.data.totalPages || 0);
 setTotalItems(res.data.totalItems || 0);
 } else {
 setItems([]);
 setTotalPages(0);
 setTotalItems(0);
 }
 setLoading(false);
 }, [page]);

 useEffect(() => {
 loadItems();
 }, [loadItems]);

 return (
 <>
 <Navbar />
 <div className="qb-page">
 <h1 className="qb-title">⚡ Quick Boost</h1>
 <p className="qb-subtitle">
 Short lessons to quickly level up your English skills.
 </p>

 {totalItems > 0 && (
 <p className="qb-count">{totalItems} lessons available</p>
 )}

 {loading ? (
 <p className="qb-loading">Loading...</p>
 ) : items.length === 0 ? (
 <p className="qb-empty">No quick boosts available yet.</p>
 ) : (
 <div className="qb-grid">
 {items.map((item) => (
 <div
 key={item.id}
 className="qb-card"
 onClick={() => navigate(`/study/quick-boost/${item.id}`)}
 >
 <h3 className="qb-card-title">{item.title}</h3>
 <span className="qb-card-date">
 {new Date(item.createdAt).toLocaleDateString("en-IN", {
 day: "numeric",
 month: "short",
 year: "numeric",
 })}
 </span>
 </div>
 ))}
 </div>
 )}

 {totalPages > 1 && (
 <div className="qb-pagination">
 <button disabled={page === 0} onClick={() => setPage(page - 1)}>
 ← Prev
 </button>
 <span>
 Page {page + 1} / {totalPages}
 </span>
 <button
 disabled={page + 1 >= totalPages}
 onClick={() => setPage(page + 1)}
 >
 Next →
 </button>
 </div>
 )}
 </div>
 <Footer />
 </>
 );
};

export default QuickBoostPage;
